var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('cube-slide',{attrs:{"data":_vm.banners}},_vm._l((_vm.banners),function(item,index){return _c('cube-slide-item',{key:index},[_c('a',{attrs:{"href":item.url}},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":item.img}})])])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }